import { Button, Offcanvas } from "react-bootstrap";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import WebService from "../../../utility/WebService";
import HelperService from "../../../utility/HelperService";
import Select from 'react-select';
import { ICoordinates, IFloorInfo, ITowerInfo } from "./ManageTower";
import { ListGroup, OverlayTrigger, Popover } from "react-bootstrap";
import { Trash } from "react-bootstrap-icons";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import MapCanvas from "../../MarkUnit/MapCanvas";
import TagInput from "../../../components/TagInput/TagInput";


interface PropData {
    isShow: boolean;
    isClose: Function;
    floor_obj: IFloorInfo | null;
    towerData: ITowerInfo[];
    project_uuid: string;
    tower_obj: ITowerInfo | null;
    base_url: string;
    mark_type: "TOWER" | "FLOOR" | "UNIT" | null;
    project_image?: string;
    coordinates_data: ICoordinates[];
}


const MarkEntity = ({ isShow, isClose, floor_obj, towerData, project_uuid, tower_obj, base_url, mark_type, project_image, coordinates_data }: PropData) => {
    const [tool, setTool] = useState("Polygon");
    const [selectedUnit, setSelectedUnit] = useState<any>();
    const [isManage, setIsManage] = useState(false);
    const [plotData, setPlotData] = useState<ICoordinates[]>([]);
    const [unitData, setUnitData] = useState<any>({ "Line": [] });
    const [markingOptions, setMarkingOptions] = useState<any>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [projectImage, setProjectImage] = useState<string>("");
    const [openTagBlade, setOpenTagBlade] = useState<boolean>(false);
    const [markData, setMarkData] = useState<any>({});
    const [tags, setTags] = useState<string[]>([]);
    const [coordinateData, setCoordinateData] = useState<ICoordinates[]>(coordinates_data || []);
 



    useEffect(() => {
        if (isShow) {
            if (mark_type == "TOWER" && project_image) {
                setProjectImage(`${base_url}${project_image}`);
                setMarkingOptions(towerData && towerData.length > 0 ? towerData.map((tower: ITowerInfo) => ({ ...tower, value: tower.id, label: tower.tower_name })) : []);
                if (coordinates_data && coordinates_data.length > 0) {
                    const data: any = coordinates_data.filter((item: any) => item.type == "TOWER");
                    setPlotData(data);
                } else {
                    setPlotData([]);
                }
            } else if (mark_type == "FLOOR" && tower_obj) {
                if (tower_obj.floor_info && tower_obj.floor_info.length == 0) {
                    toast.error("Please Add floors in selected tower");
                    isClose(false);
                }

                setProjectImage(tower_obj.image ? `${base_url}${tower_obj.image}` : "");
                setMarkingOptions(tower_obj.floor_info.map((floor: IFloorInfo) => ({ ...floor, value: floor.id, label: floor.floor_name })));
                if (coordinates_data && coordinates_data.length > 0) {
                    const data: any = coordinates_data.filter((item: any) => item.type == "FLOOR" && item.tower_id == tower_obj.id);
                    setPlotData(data);
                } else {
                    setPlotData([]);
                }
            } else if (mark_type == "UNIT" && tower_obj && floor_obj) {
                if (floor_obj.units && floor_obj.units.length == 0) {
                    toast.error("Please Add units in selected floor");
                    isClose(false);
                }

                setProjectImage(floor_obj.image ? `${base_url}${floor_obj.image}` : "");
                getUnitList(floor_obj.units);
                if (coordinates_data && coordinates_data.length > 0) {
                    const data: any = coordinates_data.filter((item: any) => item.type == "UNIT" && item.floor_id == floor_obj.id && item.tower_id == tower_obj.id);
                    setPlotData(data);
                } else {
                    setPlotData([]);
                }
            }
            setCoordinateData(coordinates_data || []);
        }
    }, [isShow, mark_type]);

    const getUnitList = (units_ids: string[]) => {
        setLoading(true);
        WebService.getAPI({ action: `get/project/unit/list?uuid=${project_uuid}` })
            .then((res: any) => { 

                if (units_ids && units_ids.length > 0 && res.list && res.list.length > 0) {
                    const list: any[] = []
                    res.list.map((item: any) => {
                        const indexOfUnit = units_ids.findIndex(id => id == item.id);
                        if (indexOfUnit > -1) {
                            list.push({ ...item, value: item.id, label: item.unit_name });
                        }
                    }); 

                    setMarkingOptions(list);
                }
                setLoading(false);
            })
            .catch((e: any) => { setLoading(false); });
    };

    const onStartMark = () => {
        if (selectedUnit) {
            setTool("Line");
        } else {
            toast.error("Please select unit");
        }
    };

    const popoverHoverFocus = (mark: any) => {
        return (
            <Popover id="popover-basic" className="p-0">
                <ListGroup as="ul" className="border-0">
                    {mark?.tags && !!mark?.tags.length && <ListGroup.Item as="li" className="border-0">Tags: {mark?.tags.join(", ")}</ListGroup.Item>}
                    <ListGroup.Item as="li" className="border-0 text-center cursor-pointer" style={{ backgroundColor: "#FDECEC", color: "#D53727" }} onClick={() => { onDeleteMark(mark.id) }}>
                        <span className="badge p-0" style={{ color: "#D53727" }}><Trash size={15} /> Remove</span>{" "}
                    </ListGroup.Item>
                </ListGroup>
            </Popover>
        );
    };

    const onCompleteMark = (data: any) => {
        if (Object.keys(data || {}).length > 1) {
            setOpenTagBlade(true);
            setMarkData(data);
        }
    };

    const onDeleteMark = (merk_id: string) => {
        const updatedCoordinates: ICoordinates[] = coordinateData.filter((item: any) => item.id != merk_id);
        WebService.postAPI({ action: `create/project-coordinates`, body: { project_uuid: project_uuid, coordinates: updatedCoordinates }, id: "add-cordinate-btn" })
            .then((res: any) => {
                setPlotData([...plotData.filter((item: any) => item.id != merk_id)]);
                toast.success("Marking deleted successfully");
            }).catch((e: any) => { });
    };

    const closeModal = (e?: boolean) => {
        setOpenTagBlade(false);
        setMarkData(null);
        setTags([]);
    };

    const saveCoordinates = () => {
        if (Object.keys(markData || {}).length > 1) {
            const coordiante: any[] = Object.values(markData).filter((item: any) => item.length > 0);
            if (coordiante.length == 0) { toast.error("Please draw marking on image"); return; };
            let new_coordiante: ICoordinates = {} as ICoordinates;
            if (mark_type == "TOWER") {
                new_coordiante = {
                    id: new Date().getTime().toString(),
                    type: "TOWER",
                    coordinates: coordiante[0],
                    tags: tags,
                    tower_id: selectedUnit.id
                };
            } else if (mark_type == "FLOOR") {
                new_coordiante = {
                    id: new Date().getTime().toString(),
                    type: "FLOOR",
                    coordinates: coordiante[0],
                    tags: tags,
                    floor_id: selectedUnit.id,
                    tower_id: tower_obj?.id || ""
                };
            } else if (mark_type == "UNIT") {
                new_coordiante = {
                    id: new Date().getTime().toString(),
                    type: "UNIT",
                    coordinates: coordiante[0],
                    tags: tags,
                    unit_id: selectedUnit.id,
                    floor_id: floor_obj?.id || "",
                    tower_id: tower_obj?.id || ""
                };
            };


            const updatedCoordinates: ICoordinates[] = [...coordinateData, new_coordiante];

            WebService.postAPI({ action: `create/project-coordinates`, body: { project_uuid: project_uuid, coordinates: updatedCoordinates }, id: "add-cordinate-btn" })
                .then((res: any) => {
                    closeModal();
                    setTool("Polygon");
                    setSelectedUnit(null);
                    setUnitData({ "Line": [] });
                    setIsManage(!isManage);
                    setPlotData([...plotData, new_coordiante]);
                    toast.success("Marking saved successfully");
                    isClose(true);
                }).catch((e: any) => { });
        } else {
            closeModal();
        }
    };

    const getMarkTitle = (mark: ICoordinates) => {
        if (mark_type == "TOWER") {
            const tower = towerData.find(t => t.id == mark.tower_id);
            return tower ? tower.tower_name : "";
        } else if (mark_type == "FLOOR") {
            const tower = towerData.find(t => t.id == mark.tower_id);
            const floor = tower?.floor_info.find(f => f.id == mark.floor_id);
            return tower && floor ? `${floor.floor_name}` : "";
        } else if (mark_type == "UNIT") {
            const tower = towerData.find(t => t.id == mark.tower_id);
            const floor = tower?.floor_info.find(f => f.id == mark.floor_id);
            const unit = markingOptions.find((u: any) => u.id == mark.unit_id);
            return tower && floor && unit ? `${unit.unit_name}` : "";
        }
        return "";
    };

    return (
        <>
            <Offcanvas show={isShow} onHide={isClose} placement="end" className="offcanvas offcanvas-ex-large">
                <Offcanvas.Header closeButton><Offcanvas.Title>Mark</Offcanvas.Title></Offcanvas.Header>
                <Offcanvas.Body className="form-style">
                    <>
                        <div style={{ height: "800px", width: "1250px" }} className="app-page">
                            <div className="d-flex gap-2 mb-3">
                                <div className="w-50">
                                    <Select className="basic-single w-100" classNamePrefix="select" isLoading={loading}
                                        isSearchable={true} options={markingOptions} onChange={(e: any) => { setSelectedUnit(e) }}
                                        value={selectedUnit} placeholder="Select Unit" />
                                </div>
                                {!isManage && <Button variant="primary" className="btn-brand-solid me-3" type="button" onClick={() => { onStartMark(); setIsManage(!isManage) }} disabled={selectedUnit && !HelperService.isEmptyObject(selectedUnit) ? false : true}>
                                    Start Marking
                                </Button>}
                            </div>
                            {projectImage} {mark_type}
                            {
                                !isManage ?
                                    <TransformWrapper>
                                        <TransformComponent>

                                            {projectImage && <svg style={{ height: "600px", width: "1250px", backgroundImage: `url(${projectImage})`, backgroundRepeat: "no-repeat", padding: "0px" }}>
                                                {plotData && !!plotData.length && plotData.map((plot: ICoordinates) => {
                                                    const points = plot.coordinates.map(([x, y]: any) => `${x},${y}`).join(" ");
                                                    const centerX = plot.coordinates.reduce((sum: any, [x]: any) => sum + x, 0) / plot.coordinates.length;
                                                    const centerY = plot.coordinates.reduce((sum: any, [, y]: any) => sum + y, 0) / plot.coordinates.length;
                                                    return (
                                                        <OverlayTrigger trigger={['click', 'focus']} placement="right" overlay={popoverHoverFocus(plot)} key={plot.id}>
                                                            <g style={{ cursor: "pointer" }}>
                                                                <polygon points={points}
                                                                    fill={"rgba(224, 255, 255, 0.4)"}
                                                                    // fill={'rgba(117, 190, 218, 0.2)'}
                                                                    stroke={''} strokeWidth="2" />
                                                                {/* Calculate text width and polygon bounding box */}
                                                                {(() => {
                                                                    const text = getMarkTitle(plot);
                                                                    if (!text) return null;
                                                                    // Calculate polygon centroid for better center placement
                                                                    const getPolygonCentroid = (coords: [number, number][]) => {
                                                                        let x = 0, y = 0, area = 0;
                                                                        const n = coords.length;
                                                                        for (let i = 0; i < n; i++) {
                                                                            const [x0, y0] = coords[i];
                                                                            const [x1, y1] = coords[(i + 1) % n];
                                                                            const a = x0 * y1 - x1 * y0;
                                                                            area += a;
                                                                            x += (x0 + x1) * a;
                                                                            y += (y0 + y1) * a;
                                                                        }
                                                                        area *= 0.5;
                                                                        if (area === 0) return [coords[0][0], coords[0][1]];
                                                                        x /= (6 * area);
                                                                        y /= (6 * area);
                                                                        return [x, y];
                                                                    };
                                                                    const [centroidX, centroidY] = getPolygonCentroid(plot.coordinates);

                                                                    // Estimate text width (simple approximation: 8px per character)
                                                                    const textWidth = text ? text.length * 8 : 40;
                                                                    // Find bounding box of polygon
                                                                    const xs = plot.coordinates.map(([x]: any) => x);
                                                                    const ys = plot.coordinates.map(([, y]: any) => y);
                                                                    const minX = Math.min(...xs);
                                                                    const maxX = Math.max(...xs);
                                                                    const minY = Math.min(...ys);
                                                                    const maxY = Math.max(...ys);
                                                                    const boxWidth = maxX - minX;
                                                                    const boxHeight = maxY - minY;
                                                                    // Set background width: min(boxWidth, textWidth + padding)
                                                                    const bgWidth = Math.min(boxWidth, textWidth + 16);
                                                                    const bgHeight = Math.min(boxHeight, 28);

                                                                    return (
                                                                        <>
                                                                            <rect x={centroidX - bgWidth / 2} y={centroidY - bgHeight / 2} width={bgWidth} height={bgHeight} fill="rgba(117, 190, 218, 0.4)" rx={6} />
                                                                            <text x={centroidX} y={centroidY} fill="#fff" fontSize="14" fontWeight="bold" textAnchor="middle" dominantBaseline="middle">
                                                                                {text}
                                                                            </text>
                                                                        </>
                                                                    );
                                                                })()}
                                                            </g>
                                                        </OverlayTrigger>
                                                    );
                                                })}
                                            </svg>}
                                        </TransformComponent>
                                    </TransformWrapper>
                                    :
                                    <div className="map-canvas">
                                        {/* {projectDetail && projectDetail?.photo_url && */}
                                        <MapCanvas data={unitData} onComplete={(e: any) => { onCompleteMark(e); }} url={projectImage} tool={tool} resetCanvas={""} />
                                        {/* } */}
                                    </div>
                            }
                        </div>

                        <Offcanvas show={openTagBlade} onHide={closeModal} placement="end">
                            <Offcanvas.Header closeButton><Offcanvas.Title> Unit-{selectedUnit && selectedUnit.unit_name}</Offcanvas.Title></Offcanvas.Header>
                            <Offcanvas.Body className="form-style">
                                <TagInput
                                    isAllowDuplicate={true}
                                    onChange={(value: string[]) => { setTags(value && value.length > 0 ? value : []) }}
                                    selected={tags || []}
                                    title="Add Tags"
                                    showStar={false}
                                />

                                <div className="text-center">
                                    <Button variant="dark" className="btn-brand-1 px-5 mt-3 mb-3 me-2" type="button" id="add-cordinate-btn" onClick={() => { saveCoordinates(); }}>
                                        Save
                                    </Button>
                                    <Button variant="light" className="btn-brand-1 px-5 mt-3 mb-3" type="button" onClick={() => closeModal(false)}>
                                        Cancel
                                    </Button>
                                </div>
                            </Offcanvas.Body>
                        </Offcanvas>
                    </>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
};

export default MarkEntity;
